module.exports = __webpack_public_path__ + "7.b7e2a029.png";